<!-- Main Signup Content -->
<div class="signup-container">
  <div class="signup-content">
    <!-- Logo Section -->
    <div class="logo-section">
      <img src="assets/logo-transparent.svg" alt="Hebern Logo" class="logo" />
    </div>

    <!-- Main Welcome Message -->
    <div class="welcome-message">
      <h1 class="welcome-title">
        <span class="welcome-title-line">Secure Your Data Stream in Seconds. </span>
        <span class="welcome-title-line">Beta now open!</span>
      </h1>
      <ul class="welcome-bullets" role="list">
        <li>Quick easy setup.</li>
        <li>Platform and form agnostic.</li>
        <li>AI can't mess up the process or lose your keys.</li>
        <li>Special lifetime pricing for beta testers.</li>
      </ul>
      <p class="welcome-subtitle">
        Sign up to receive updates about our product or if you are interested in becoming a beta tester.
      </p>
    </div>

    <!-- Signup Form Component -->
    <section id="signup" class="signup-section">
      <app-signup-form></app-signup-form>
    </section>

    <!-- Footer Message -->
    <div class="footer-message">
      <p>Questions? We're here to help. Reach out to us anytime.</p>
      <p class="email-link">
        <a href="mailto:support@hebern.com">support@hebern.com</a>
      </p>
    </div>
  </div>
</div>
